module.exports = __webpack_public_path__ + "media/images/astronaut-45136d6dca08846e7c32d3c2628f1d80.svg";